/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { RadioButton, RadioGroup } from '@vaisala-rockhopper/components';
import './EnhancedRadioGroup.scss';

interface EnhancedRadioGroupProps {
  options: any[];
  value: any;
  onChange: (value: any) => void;
  indexAsValue?: boolean;
}

const EnhancedRadioGroup = ({ options, value, onChange, indexAsValue }: EnhancedRadioGroupProps) => {
  const { t } = useTranslation();
  return (
    <RadioGroup className="enhanced-radio-group" value={`${value}`} onChange={(evt) => onChange(evt.target.value)}>
      {options.map((option, i) => {
        return (
          <RadioButton key={i} value={indexAsValue ? i : option}>
            {t(option)}
          </RadioButton>
        );
      })}
    </RadioGroup>
  );
};

export default EnhancedRadioGroup;
